var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRentalMarketing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_3241)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_3241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 79,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.21875H78.4V33.6H0V5.21875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_3241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0437012 30.8125L38.4062 5.71875L39.175 5.21875L39.9375 5.71875L78.2875 30.8062L76.7562 33.1313L39.175 8.54375L1.5687 33.1438L0.0437012 30.8125Z",
    fill: "#212121"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1624 11.332C40.5249 11.332 41.7562 11.882 42.6437 12.7695C43.5374 13.657 44.0874 14.882 44.0874 16.2383C44.0874 17.5945 43.5374 18.8195 42.6437 19.707C41.7562 20.5945 40.5249 21.1445 39.1624 21.1445C37.8062 21.1445 36.5749 20.5945 35.6812 19.707C34.7937 18.8195 34.2437 17.5945 34.2437 16.2383C34.2437 14.882 34.7937 13.657 35.6812 12.7695C36.5749 11.882 37.8062 11.332 39.1624 11.332ZM40.6687 14.7383C40.2874 14.3508 39.7499 14.1133 39.1624 14.1133C38.5749 14.1133 38.0437 14.3508 37.6562 14.7383C37.2749 15.1195 37.0374 15.6508 37.0374 16.2383C37.0374 16.8258 37.2749 17.357 37.6562 17.7383C38.0437 18.1195 38.5749 18.357 39.1624 18.357C39.7499 18.357 40.2874 18.1195 40.6687 17.7383C41.0562 17.357 41.2937 16.8258 41.2937 16.2383C41.2937 15.6508 41.0562 15.1195 40.6687 14.7383Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0124 34.168H36.1999C36.9749 34.168 37.5999 34.793 37.5999 35.5617V62.193C37.5999 62.9617 36.9749 63.5805 36.1999 63.5805H21.0124C20.2437 63.5805 19.6187 62.9617 19.6187 62.193V35.5617C19.6187 34.793 20.2437 34.168 21.0124 34.168ZM34.8062 36.9555H22.4124V60.7992H34.8062V36.9555Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6938 22.707H64.6313C65.4063 22.707 66.0313 23.3258 66.0313 24.1008V44.257H63.2375V25.4883H15.0938V60.8008H51.9875V62.3445C51.9875 62.7883 52.0938 63.2133 52.2813 63.582H13.6938C12.925 63.582 12.3 62.9633 12.3 62.1945V24.1008C12.3 23.3258 12.925 22.707 13.6938 22.707Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.125 34.168H57.3125C58.0812 34.168 58.7062 34.793 58.7062 35.5617V44.2555H55.9187V36.9555H43.5187V49.3305H51.9875V52.118H42.125C41.3562 52.118 40.7312 51.493 40.7312 50.7242V35.5617C40.7312 34.793 41.3562 34.168 42.125 34.168Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_94_3241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 62,
    width: 4,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6187 62.2695H72.5312V83.3758H69.6187V62.2695Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_94_3241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4813 62.3438V83.3813H69.6875V62.3438H72.4813Z",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_94_3241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 45,
    width: 36,
    height: 19
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.375 45.5879H88.7812V63.9629H53.375V45.5879Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_94_3241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7813 45.6504H87.3876C88.1563 45.6504 88.7813 46.2754 88.7813 47.0441V62.3441C88.7813 63.1129 88.1563 63.7379 87.3876 63.7379H54.7813C54.0063 63.7379 53.3813 63.1129 53.3813 62.3441V47.0441C53.3813 46.2754 54.0063 45.6504 54.7813 45.6504ZM85.9876 48.4379H56.1751V60.9504H85.9876V48.4379Z",
    fill: "#212121"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3875 57.8695V51.5195H62.0937C62.775 51.5195 63.2687 51.5758 63.5812 51.6883C63.8875 51.8008 64.1312 52.007 64.3187 52.3008C64.5062 52.5883 64.6 52.9258 64.6 53.3008C64.6 53.7758 64.4562 54.1695 64.175 54.482C63.8937 54.7883 63.475 54.9883 62.9125 55.0633C63.1937 55.232 63.425 55.407 63.6062 55.6008C63.7875 55.7945 64.0312 56.1383 64.3375 56.632L65.1125 57.8695H63.575L62.6437 56.4883C62.3187 55.9945 62.0937 55.682 61.9687 55.557C61.85 55.4258 61.7187 55.3383 61.5812 55.2883C61.4437 55.2445 61.2312 55.2195 60.9312 55.2195H60.675V57.8695H59.3875ZM60.675 54.207H61.625C62.2437 54.207 62.625 54.1758 62.7812 54.1258C62.9375 54.0758 63.0562 53.9883 63.1437 53.857C63.225 53.732 63.275 53.5695 63.275 53.382C63.275 53.1695 63.2125 52.9945 63.1 52.8633C62.9875 52.732 62.825 52.6508 62.6125 52.6133C62.5125 52.6008 62.2 52.5945 61.675 52.5945H60.675V54.207ZM65.8125 57.8695V51.5195H70.5312V52.5945H67.0937V54.0008H70.2937V55.0695H67.0937V56.8008H70.6562V57.8695H65.8125ZM71.7562 57.8695V51.5195H73.0125L75.6187 55.757V51.5195H76.8125V57.8695H75.5187L72.95 53.7258V57.8695H71.7562ZM79.6062 57.8695V52.5945H77.7187V51.5195H82.7812V52.5945H80.8937V57.8695H79.6062Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_3241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentalMarketing);
export default __webpack_public_path__ + "static/media/RentalMarketing.f44aa0729766532b3a43097f0a2572b4.svg";
export { ForwardRef as ReactComponent };